<template>
    <div class="d-flex flex-column h-100" id="app">
        <div class="login row row-eq-height m-0 ht-100 col-sm-12 bg-light">
            <div class="col-sm-12 right-section homebody" style="margin-top: 70px;">
                <div class="row">
                    <div class="col-sm-4">
                    </div>
                    <div class="w-100 p-5 mt-auto col-sm-4 card">
                        <span class="align-center">
                            <img src="../../assets/gray.png" height="60" width="150" class="mb-3">
                        </span>
                        <h2 class="d-block pt-2 login-label align-center">Welcome to Login Page</h2>
                        <form class="w-480 mt-5" @submit.prevent="handleSubmit">
                            <label for="username" class="login-label font-bold">User Name</label>
                            <div class="form-group input-group">
                                <div class="input-group-append">
                                    <span class="input-group-text">
                                        <font-awesome-icon :icon="['fas', 'user']" class="icon alt" />
                                    </span>
                                </div>
                                <input type="text" v-model="username" v-validate="'required'" id="username" name="username" class="form-control" :class="{ 'is-invalid': submitted && errors.has('username') }" />
                                <div v-if="submitted && errors.has('username')" class="invalid-feedback">{{ errors.first('username') }}</div>
                            </div>
                            <label for="password" class="login-label font-bold">Password</label>
                            <div class="form-group input-group">
                                <div class="input-group-append">
                                    <span class="input-group-text">
                                        <font-awesome-icon :icon="['fas', 'lock']" class="icon alt" />
                                    </span>
                                </div>
                                <input type="password" v-model="password" v-validate="{ required: true, min: 6 }" id="password" name="password" class="form-control" :class="{ 'is-invalid': submitted && errors.has('password') }" />
                                <div v-if="submitted && errors.has('password')" class="invalid-feedback">{{ errors.first('password') }}</div>
                            </div>
                            <div v-if="showInvalidCredentials" class="form-group alert alert-danger alert-dismissible fade show">
                                <div class="col text-center">
                                    <strong> Username or Password is incorrect </strong>
                                </div>
                            </div>
                            <div class="form-group">
                                <button class="btn btn-lg btn-primary btn-block eyprim-btn" type="submit" :disabled="errors.any()">Login</button>
                            </div>
                        </form>
                    </div>
                    <div class="col-sm-4">
                    </div>
                </div>
                <div class="row w-480 p-4 mt-auto">
                    <div class="col-sm-4">
                    </div>
                    <div class="col-sm-4 login-label align-center font-bold">
                        ©2019 EYGM Limited | All rights reserved.
                    </div>
                    <div class="col-sm-4">
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import LoginService from '../../services/login.service.js';
    export default {
        name: 'Login',
        mixins: [LoginService],
        data() {
            return {
                username: '',
                password: '',
                submitted: false,
                showInvalidCredentials: false
            }
        },
        created() {
            // reset login status
            this.logout();
            // get return url from route parameters or default to '/'
            //this.returnUrl = this.$route.query.returnUrl || '/';
            localStorage.setItem("route", this.$route.name);
        },
        methods: {
            handleSubmit() {
                this.submitted = true;
                this.$validator.validate().then(valid => {
                    if (valid) {
                        this.login(this.username, this.password).then(Response => {
                            if (Response) {
                                if (Response.data.message == "Username or password is incorrect") {
                                    this.showInvalidCredentials = true;
                                }
                                else {
                                    this.$store.state.isLoggedIn = true;
                                    localStorage.setItem('userName', Response.data.userName);
                                    localStorage.setItem('userId', Response.data.userId);
                                    localStorage.setItem('token', Response.data.token);
                                    localStorage.setItem('role', Response.data.role);
                                    localStorage.setItem('appName', Response.data.appName);
                                    if (Response.data.appName == "CIT") {
                                        this.$router.push("/CITHome");
                                    }
                                    if (Response.data.appName == "MEMO") {
                                        this.$router.push("/Home");
                                    }
                                    if (Response.data.appName == "BRC") {
                                        this.$router.push("/ACRHome");
                                    }
                                    if (Response.data.appName == "USBRGAAP") {
                                        this.$router.push("/USBRGAAPHome");
                                    }
                                }
                            }
                            else {
                                this.$store.data.isLoggedIn = false;
                            }
                        });
                    }
                });
            }
        }
    };
</script>
<style>
    .login-label {
        color: #808080d9;
    }

    .is-invalid {
        border-color: #E84444;
        box-shadow: inset 0 1px 1px rgba(0,0,0,.075), 0 0 8px rgba(232,68,68,.6);
    }
</style>